import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { CUSTOMERS_COUNT, HOME_PAGE_HEADLINE01, HOME_PAGE_HEADLINE02, HOME_PAGE_HEADLINE03, PHOTOS_01, SITE_TITLE, TAGS_CLOUD_01 } from '../../shared/constants';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { afterNextRender, Component, ElementRef, OnDestroy, OnInit, HostListener, ChangeDetectionStrategy } from '@angular/core';

import { Meta, Title } from '@angular/platform-browser';
import { CounterWidget } from '../../domain/counter';
import { HttpClient } from "@angular/common/http"
import { Product } from '../../domain/product';
import { ProductService } from '../products/product.service';
import { TagCloudComponent } from "../../components/sections/tag-cloud/tag-cloud.component";
import { FeaturesComponent } from '../../components/sections/features/features.component';
import { CounterComponent } from '../sections/counter/counter.component';
import { GalleryWidget } from '../../domain/gallery';
import { FloatingShapesComponent } from '../sections/floating-shapes/floating-shapes.component';

@Component({
  selector: 'app-home',
  imports: [
    MatToolbarModule,
    RouterModule,
    FeaturesComponent,
    CounterComponent,
    TagCloudComponent,
    FloatingShapesComponent,
],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss'
})

export class HomeComponent implements OnInit, OnDestroy {
  private revealObserver?: IntersectionObserver;

  constructor(private meta: Meta, private title: Title,
    private http: HttpClient,
    private productService: ProductService,
    private elementRef: ElementRef<HTMLElement>,
  ) {
    // afterNextRender so this only runs in the browser, after hydration has settled.
    afterNextRender(() => this.setupRevealObserver());
  }

  HOME_PAGE_HEADLINE01: string = HOME_PAGE_HEADLINE01
  HOME_PAGE_HEADLINE02: string = HOME_PAGE_HEADLINE02
  HOME_PAGE_HEADLINE03: string = HOME_PAGE_HEADLINE03
  heroSubtitle: string = HOME_PAGE_HEADLINE03.replace(/\s*Contact us today.*$/i, '');

  text: string = HOME_PAGE_HEADLINE02;
  textArray: string[] = [];

  images: string[] = [
    'images/home/cam-lock-panels-01.png',
    'images/home/metal-insulated-panel-01.png',
    'images/home/walkin-cooler-01.png',
  ];

  currentIndex: number = 0;
  intervalId: any;

  counterWidget: CounterWidget = new CounterWidget()
  galleryWidget: GalleryWidget = new GalleryWidget()

  section01: string = ""
  tagsCloud: string[] = []
  products: Product[] = []

  sectorsOfWOrk: { name: string; detail: string; icon: string }[] = [
    { name: 'Real Estate', icon: 'bi-building', detail: 'Automate lead intake, follow-ups, and deal pipeline updates.' },
    { name: 'Retail', icon: 'bi-shop', detail: 'Campaign automation, customer segmentation, and sales reporting.' },
    { name: 'Healthcare', icon: 'bi-heart-pulse-fill', detail: 'Streamline patient intake, appointment reminders, and care coordination workflows.' },
    { name: 'Finance & FinTech', icon: 'bi-bank2', detail: 'Automate onboarding, compliance checks, and reporting across your financial products.' },
    { name: 'Hospitality', icon: 'bi-cup-hot-fill', detail: 'Coordinate bookings, guest communication, and loyalty programs from one place.' },
    { name: 'Manufacturing & Logistics', icon: 'bi-truck', detail: 'Track inventory, shipments, and supplier communication in real time.' },
  ];

  testimonials: { quote: string; author: string; role: string }[] = [
    {
      quote: 'NordNative has been a game-changer for our business. Their innovative solutions and exceptional service have exceeded our expectations!',
      author: 'Sarfraz Bugti',
      role: 'CEO, Friends Builders (Pvt) Limited',
    },
    {
      quote: 'The team at NordNative is highly professional and dedicated. Their products have significantly improved our operational efficiency.',
      author: 'John Konnings',
      role: 'Founder and CEO, Tera Bytes',
    },
  ];

  getInitials(name: string): string {
    return name
      .split(' ')
      .filter(Boolean)
      .map(part => part[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  scrollToSection(event: Event, id: string): void {
    event.preventDefault();
    const el = this.elementRef.nativeElement.querySelector(`#${id}`);
    if (!el) {
      return;
    }
    const reduceMotion = typeof window !== 'undefined'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  ngOnInit(): void {
    this.title.setTitle(SITE_TITLE + ' | Sales & Marketing Automation Software');
    this.meta.updateTag({ name: 'description', content: 'NordNative provides BunnyCRM, a SaaS platform for sales and marketing automation.' });
    this.meta.updateTag({ name: 'keywords', content: 'sales automation, marketing automation, SaaS, BunnyCRM' });

    //this.counterWidget.title = "Dev Centers"
    this.counterWidget.counters = CUSTOMERS_COUNT

    this.galleryWidget.title = "Our values"
    this.galleryWidget.photos = PHOTOS_01

    this.tagsCloud = TAGS_CLOUD_01
    this.products = this.productService.getProducts()

    //this.startAnimation();
    this.textArray = this.text.split(''); // Split the text into individual characters

    //this.http.get('html/home/rain.html', { responseType: 'text' }).subscribe(data => this.section01 = data);
  }

  private setupRevealObserver(): void {
    this.revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.revealObserver?.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 12% 0px' });

    this.elementRef.nativeElement
      .querySelectorAll<HTMLElement>('[data-reveal]')
      .forEach(el => this.revealObserver?.observe(el));
  }

  startAnimation(): void {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 3000); // Change image every 3 seconds
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.revealObserver?.disconnect();
  }


  // activeSection: string | null = null;

  // onHover(sectionId: string): void {
  //   this.activeSection = sectionId;
  // }

  // onLeave(): void {
  //   this.activeSection = null;
  // }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(): void {
  //   if (this.activeSection) {
  //     const element = document.getElementById(this.activeSection);
  //     if (element) {
  //       element.classList.add('scrolling');
  //       setTimeout(() => {
  //         element.classList.remove('scrolling');
  //       }, 500); // Match the animation duration in CSS
  //     }
  //   }
  // }
}
